import { render } from "./editModal.vue?vue&type=template&id=60baa997&ts=true"
import script from "./editModal.vue?vue&type=script&lang=ts"
export * from "./editModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__